import dataService from '../../data/data.service';
import _ from 'lodash';

const state = {
  accountAgeGroups: []
}

const getters = {
    accountAgeGroups: (state) => {
    return state.accountAgeGroups
  }
}

const actions = {
  get(context, sessionId) {
    return new Promise(resolve => {
      dataService.modules.accountAge.get(sessionId).then(data => {
        context.commit('get', data);
        resolve();
      });
    })
  },
  add(context, accountAge) {
    return new Promise(resolve => {
      dataService.modules.accountAge.add(accountAge).then(id => {
        accountAge.id = id.data[0];
        context.commit('add', accountAge);
        resolve()
      });
    });
  },
  delete(context, session) {
    return new Promise(resolve => {
      dataService.modules.accountAge.delete(session).then(() => {
        //context.commit('delete', data);
        resolve();
      });
    });
  },
}

const mutations = {
  get(state, data) {
    state.accountAgeGroups = data;
  },
  add(state, data) {
    state.accountAgeGroups.push(data)
  },
  //delete(state, data) {
    //var ageToDelete = _.findIndex(state.accountAgeGroups, data);
    //state.accountAgeGroups.splice(ageToDelete, 1)
  //},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}